import { Chip } from "@mui/material";
import React,{useMemo,memo} from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const Co2KPI = memo(({avgCO2,maxCO2, minCO2}) => {
  const percentage = useMemo(()=>{
  
    if (avgCO2 >2000  && avgCO2 <=5000) return 0.2;
    if (avgCO2 > 1000 && avgCO2 <= 2000) return 0.5;
    if (avgCO2 >= 0 && avgCO2 <= 1000) return 0.8;
    
    return 0.2; 
  
  },[avgCO2])
  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1,0.1,0.1]}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage}
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgCO2} ppm</span>
      <p className="card-value">CO2</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max"  sx={chipStyle} />
          <p className="m-1 p-0">{maxCO2}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle} />
          <p className="m-1 p-0">{minCO2}</p>
        </div>
      </div>
    </>
  );
});

export default Co2KPI;
